import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getPropulsionTypeList(params) {
  return request({
    url: URL.mdm.basicData.propulsionType,
    method: 'get',
    params
  })
}

export function savePropulsionType(data) {
  return request({
    url: URL.mdm.basicData.propulsionType,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delPropulsionType(uuid) {
  return request({
    url: URL.mdm.basicData.propulsionType + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}
